import { render, staticRenderFns } from "./ModuleSchemePreview.vue?vue&type=template&id=0fe34efa&scoped=true"
import script from "./ModuleSchemePreview.vue?vue&type=script&lang=js"
export * from "./ModuleSchemePreview.vue?vue&type=script&lang=js"
import style0 from "./ModuleSchemePreview.vue?vue&type=style&index=0&id=0fe34efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe34efa",
  null
  
)

export default component.exports